import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as api from "api/api";
import { MobileSettingsResource } from "api/resource/mobile-settings";
import { loginReset } from "redux/slice/authentication";

export interface MobileSettingsState {
    loading?: boolean;
    error?: string | null;
    mobileSettings?: MobileSettingsResource;
}

const initialState: MobileSettingsState = {
    loading: false,
};

export const fetchMobileSettings = createAsyncThunk("mobileSettings/fetch", async (_, thunkAPI) => {
    thunkAPI.dispatch(mobileSettingsLoading());
    const result = api.getMobileSettings();
    result
        .then((s) => thunkAPI.dispatch(mobileSettingsLoaded(s)))
        .catch((e) => thunkAPI.dispatch(mobileSettingsFailed(e)));
    return result;
});

export const saveMobileSettings = createAsyncThunk("mobileSettings/save", async (payload: MobileSettingsResource, thunkAPI) => {
    thunkAPI.dispatch(mobileSettingsLoading());
    const result = api.updateMobileSettings(payload);
    result
        .then((s) => thunkAPI.dispatch(mobileSettingsLoaded(s)))
        .catch((e) => thunkAPI.dispatch(mobileSettingsFailed(e)));
    return result;
});

export const mobileSettingsSlice = createSlice({
    name: "mobileSettings",
    initialState,
    reducers: {
        mobileSettingsLoading: (state) => {
            state.loading = true;
        },
        mobileSettingsLoaded: (state, action: PayloadAction<MobileSettingsResource>) => {
            state.loading = false;
            state.error = null;
            state.mobileSettings = action.payload;
        },
        mobileSettingsFailed: (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload.message;
        },
        default: (state) => {
            return state;
        },
    },
    extraReducers(builder) {
        builder.addCase(loginReset, () => {
            return initialState;
        });
    },
});

export const { mobileSettingsLoading, mobileSettingsLoaded, mobileSettingsFailed } = mobileSettingsSlice.actions;
